import angular from 'angular';
import './style.scss';
import $ from 'jquery';
import _ from 'lodash';
import Logger from '../../../shared/logger';
import template from './template.html';
import defaultAssociatedEmployersSettings from './defaultAssociatedEmployersSettings';
import { EmployerRepAuthTypes } from '../../../constants/employerRepAuthTypes';
import UtilsService from '../../../services/utilsService';

const MAX_SUGGEST_COMPANIES = 10;
const MIN_COMPANY_NAME_LENGTH_TO_SEARCH = 3;

const InterestedCandidateContacts = {
    PHONE: 'phone',
    EMAIL: 'email',
};

const AutoCampaignTypes = {
    DIVERSITY: 'diversity',
    REGULAR: 'regular',
    HYBRID: 'hybrid',
};

const DiversityTargets = {
    FEMALE: 'female',
    BLACK: 'black',
    HISPANIC: 'hispanic',
    ASIAN: 'asian',
    VETERAN: 'veteran',
};

export class DefaultAssociatedEmployersSettings {
    /* @ngInject */
    constructor(
        $state,
        $scope,
        CompanyService,
        EmployerService,
        EmployerRepService,
        IdentifiersService,
        $stateParams,
        $cookies,
        $timeout,
        LocationService,
        $q,
        $translate,
        $window,
        RouteService,
        permissions,
        NotificationService,
        OfficeService,
        staticDataService,
        RecruiterService,
        WebAppRouteService,
        ModalDialogService,
        CampaignService,
    ) {
        this.companyService = CompanyService;
        this.locationService = LocationService;
        this.staticDataService = staticDataService;
        this.identifiersService = IdentifiersService;
        this.WebAppRouteService = WebAppRouteService;
        this.notificationService = NotificationService;
        this.ModalDialogService = ModalDialogService;
        this.$scope = $scope;
        const ctrl = this;
        ctrl.isGenerateSpecialtiesButtonEnabled = ctrl.getIsGenerateSpecialtiesButtonEnabled();
        ctrl.isCompaniesLoading = false;
        ctrl.isSpecialtiesLoading = false;
        ctrl.isTalentExpertUser = permissions.isTalentExpertUser();
        ctrl.isTalenyaUser = permissions.isTalenyaUser();
        ctrl.isSuperUser = permissions.isTalentExpertUser() || permissions.isTalenyaUser();
        ctrl.countriesList = [];

        ctrl.AutoCampaignTypes = AutoCampaignTypes;
        ctrl.DiversityTargets = DiversityTargets;
        ctrl.EmployerRepAuthTypes = EmployerRepAuthTypes;

        ctrl.isRecalibrationFlowEnabled = RouteService.getSystemPreference('isRecalibrationFlowEnabled');

        ctrl.diversityOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_OFF_OPTION', value: false },
        ];
        ctrl.diversityReportOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_REPORT_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_REPORT_OFF_OPTION', value: false },
        ];
        ctrl.diversityTagOptions = [
            { label: 'EMPLOYER_PROFILE_DIVERSITY_TAG_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_DIVERSITY_TAG_OFF_OPTION', value: false },
        ];
        ctrl.campaignEngagementOptions = [
            { label: 'EMPLOYER_CAMPAIGN_ENGAGEMENT_ON_OPTION', value: true },
            { label: 'EMPLOYER_CAMPAIGN_ENGAGEMENT_OFF_OPTION', value: false },
        ];
        ctrl.linkedinConnectionsOptions = [
            { label: 'EMPLOYER_LINKEDIN_CONNECTIONS_ON_OPTION', value: true },
            { label: 'EMPLOYER_LINKEDIN_CONNECTIONS_OFF_OPTION', value: false },
        ];

        ctrl.linkedinInMailConnectionsOptions = [
            { label: 'EMPLOYER_LINKEDIN_IN_MAIL_CONNECTIONS_ON_OPTION', value: true },
            { label: 'EMPLOYER_LINKEDIN_IN_MAIL_CONNECTIONS_OFF_OPTION', value: false },
        ];

        ctrl.campaignsAnalysisPageOptions = [
            { label: 'EMPLOYER_CAMPAIGNS_ANALYSIS_PAGE_ON_OPTION', value: true },
            { label: 'EMPLOYER_CAMPAIGNS_ANALYSIS_PAGE_OFF_OPTION', value: false },
        ];

        ctrl.contactForEmployerOptions = [
            { label: 'EMPLOYER_CONTACT_ON_OPTION', value: true },
            { label: 'EMPLOYER_CONTACT_OFF_OPTION', value: false },
        ];
        ctrl.profileHiddenDetailsPreviewOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.showManageJobOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.isProfileFeedbackModeEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.isNewLandingPageEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.showWizardSamplesPageOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.isEmployerPostScrapingEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.jobWizardFastRatingOptions = [
            { label: 'WIZARD_FAST_RATING_OPTION_ON', value: true },
            { label: 'WIZARD_FAST_RATING_OPTION_OFF', value: false },
        ];

        ctrl.onlyFastRatingAllowedOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.skipCalibrationForSimilarJobsAllowedOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.isRecalibrationEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.isManualQualifyEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.isManualQualifyManualFlowEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.isManualQualifyLowTalentPoolEnabledOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.isManualQualifyManualMessagingEnabledOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.switchOnAutoCampaignOnCompleteCalibrationOptionsOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.autoCampaignTypeOptions = [
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_RADIO_BUTTON_REGULAR_CAMPAIGN_LABEL', value: AutoCampaignTypes.DIVERSITY },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_RADIO_BUTTON_REGULAR_HYBRID_LABEL', value: AutoCampaignTypes.HYBRID },
        ];

        ctrl.autoCampaignDiversityOptions = [
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_WOMEN', value: 'female' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_BLACK', value: 'black' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_HISPANIC', value: 'hispanic' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_ASIAN', value: 'asian' },
            { label: 'EMPLOYER_POSITION_START_AUTO_CAMPAIGN_DIALOG_CHECKBOX_VETERANS', value: 'veteran' },
        ];

        ctrl.GDPROptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.yesNoOptions = [
            { label: 'YES', value: true },
            { label: 'NO', value: false },
        ];

        ctrl.onOffOptions = [
            { label: 'On', value: true },
            { label: 'Off', value: false },
        ];

        ctrl.companiesExcludeOptions = [
            { label: 'Current', value: '-2' },
            { label: 'Current or Past', value: '-1' },
        ];

        ctrl.atsAutoUploadFilterEnabledOptions = [
            { label: 'Enabled', value: true },
            { label: 'Disabled', value: false },
        ];

        ctrl.atsJobIdOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_JOB_ID_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_JOB_ID_OFF_OPTION', value: false },
        ];

        ctrl.atsJobUrlOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_JOB_URL_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_JOB_URL_OFF_OPTION', value: false },
        ];

        ctrl.atsRecruiterOptions = [
            { label: 'EMPLOYER_PROFILE_ATS_RECRUITER_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_ATS_RECRUITER_OFF_OPTION', value: false },
        ];

        ctrl.interestedCandidateRequiredContactOptions = [
            { label: 'Mandatory', value: true },
            { label: 'Optional', value: false },
        ];

        ctrl.bulkActionsContactByLinkedInEnabledOptions = [
            { label: 'EMPLOYER_PROFILE_BULK_ACTIONS_CONTACT_BY_LINKEDIN_ENABLED_ON_OPTION', value: true },
            { label: 'EMPLOYER_PROFILE_BULK_ACTIONS_CONTACT_BY_LINKEDIN_ENABLED_OFF_OPTION', value: false },
        ];

        ctrl.programmaticCampaignOptions = [
            { label: 'Off', value: '' },
            { label: 'All Jobs', value: 'auto' },
            { label: 'Per Job', value: 'manual' },
        ];

        ctrl.init = async function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            ctrl.outSideUser = false;

            ctrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length == 0 && !$noteEditor.is(event.target)) {
                                // click outside of summernote
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };

            UtilsService.cookiesOverride($cookies);

            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
            const userData = UtilsService.parseJSON($cookies.get('userData'));

            if (!userData?.roles || userData?.roles?.length === 0) {
                if (userPrefs.entityId) {
                    $state.go('register');
                    return;
                }
                RouteService.addUserData({
                    user_metadata: {
                        user_signup: 'employer',
                    },
                });
                ctrl.outSideUser = true;
            } else if (permissions.isTalentExpertUser()
                || userData?.roles.indexOf('AM') >= 0) {
                ctrl.talenyaUserAM = true;
            }

            ctrl.isNew = false;

            if (_.isEmpty($stateParams.resellerEmployerData)) {
                try {
                    const response = await EmployerService.getEmployer($stateParams.empId);
                    ctrl.resellerEmployerData = response.result;
                } catch (error) {
                    Logger.error(error);
                    NotificationService.error('EMPLOYER_DETAILS_FORM_SPECIALTIES_GENERATE_ERROR');
                }
            } else {
                ctrl.resellerEmployerData = $stateParams.resellerEmployerData;
            }

            if (!ctrl.resellerEmployerData.defaultAssociatedEmployersSettings) {
                defaultAssociatedEmployersSettings.settings.isDemoEmployer = _.get(ctrl, 'resellerEmployerData.settings.isDemoEmployer', false);
                defaultAssociatedEmployersSettings.settings.atsType = _.get(ctrl, 'resellerEmployerData.settings.atsType', '');
                defaultAssociatedEmployersSettings.settings.authData = _.get(ctrl, 'resellerEmployerData.settings.authData', {});
                defaultAssociatedEmployersSettings.settings.atsProgrammaticSourceId = _.get(ctrl, 'resellerEmployerData.settings.atsProgrammaticSourceId', '');

                ctrl.defaultAssociatedEmployersSettings = {
                    ...defaultAssociatedEmployersSettings,
                    defaultAccountManagerRecruiter: ctrl.resellerEmployerData.defaultAccountManagerRecruiter,
                    defaultAssociatedRecruiter: ctrl.resellerEmployerData.defaultAssociatedRecruiter,
                };
            } else {
                ctrl.defaultAssociatedEmployersSettings = {
                    ...defaultAssociatedEmployersSettings,
                    ...ctrl.resellerEmployerData.defaultAssociatedEmployersSettings,
                    settings: {
                        ...ctrl.resellerEmployerData.settings,
                        ...ctrl.resellerEmployerData.defaultAssociatedEmployersSettings.settings,
                    },
                };

                ctrl.defaultAssociatedEmployersSettings.settings.isDemoEmployer = ctrl.resellerEmployerData.settings.isDemoEmployer;

                ctrl.defaultAssociatedEmployersSettings.settings.isAutoInviteToRateEnabled = _.get(ctrl, 'defaultAssociatedEmployersSettings.settings.isAutoInviteToRateEnabled', false);

                ctrl.defaultAssociatedEmployersSettings.settings.programmaticCampaignType = _.get(ctrl, 'defaultAssociatedEmployersSettings.settings.programmaticCampaignType', '');
            }

            Promise.all([
                CampaignService.searchCampaign({ filter: { type: 'system', role: 'TE', statuses: ['active'] } }),
                CampaignService.searchCampaign({ filter: { employerId: $stateParams.empId, type: 'employer', statuses: ['active'] } }),
            ]).then(([systemCampaignsResponse, employerCampaignsResponse]) => {
                const systemCampaignsTE = systemCampaignsResponse.result || [];
                const employerCampaigns = employerCampaignsResponse.result || [];

                const campaignsForRecruiter = [...systemCampaignsTE, ..._.filter(employerCampaigns, (c) => c.senderUser?.role === 'TE')];
                const campaignsForEmployerRep = _.filter(employerCampaigns, (c) => c.senderUser?.role === 'EM');

                const getSortedCampaignOptions = (campaigns) => _.chain(campaigns)
                    .map((c) => ({ label: c.name, value: c._id }))
                    .orderBy([(c) => c?.label?.toLowerCase()], ['asc'])
                    .value();

                const campaignsForRecruiterOptions = getSortedCampaignOptions(campaignsForRecruiter);
                const campaignsForEmployerRepOptions = getSortedCampaignOptions(campaignsForEmployerRep);

                ctrl.campaignsForRecruiterOptions = campaignsForRecruiterOptions;
                ctrl.campaignsForEmployerRepOptions = campaignsForEmployerRepOptions;
            });

            EmployerService.getSpecialtiesUpdateStatus($stateParams.empId)
                .then((response) => {
                    ctrl.isSpecialtiesUpdated = _.get(response, 'result.isSpecialtiesUpdated');
                })
                .catch((error) => Logger.error(error));
        };

        ctrl.transformDataForView = function (employerData) {
            for (const path of ['companies', 'specialties', 'settings.atsAutoUploadFilter']) {
                const selected = _.chain(employerData)
                    .get(path)
                    .map((value) => ({
                        value,
                        text: value,
                    }))
                    .value();

                _.set(employerData, path, {
                    ...ctrl.initialData[path],
                    selected,
                });
            }
        };

        ctrl.generateSpecialties = async function () {
            ctrl.isSpecialtiesLoading = true;

            const selectedCompanies = _.chain(ctrl.employerData)
                .get('companies.selected', [])
                .map('value')
                .value();
            try {
                const { result: companies } = await this.companyService.searchCompanyByNames(selectedCompanies);
                ctrl.employerData.companiesInfoLastUpdate = companies.map(({ CompanyName, LastUpdateDate }) => ({
                    companyName: CompanyName,
                    lastUpdated: LastUpdateDate,
                }));
                const newSpecialties = _.chain(companies)
                    .map('Specialties')
                    .flatten()
                    .map((item) => ({
                        value: item,
                        text: item,
                    }))
                    .value();
                // eslint-disable-next-line max-len
                const lowerCasedSelectedSpecialties = ctrl.employerData.specialties.selected.map((item) => (item.value.toLowerCase()));

                for (const newSpecialty of newSpecialties) {
                    const newSpecialtyLowerCased = _.get(newSpecialty, 'value', '').toLowerCase();
                    if (!lowerCasedSelectedSpecialties.includes(newSpecialtyLowerCased)) {
                        ctrl.employerData.specialties.selected.push(newSpecialty);
                    }
                }
                ctrl.isSpecialtiesLoading = false;
                this.$scope.$apply();
            } catch (error) {
                Logger.error(error);
                NotificationService.error('EMPLOYER_DETAILS_FORM_SPECIALTIES_GENERATE_ERROR');
            }
        };

        const _searchForMatchCompanies = async function () {
            const isCompaniesFieldEmpty = _.get(ctrl.employerData, 'companies.selected.length', 0) === 0;
            const companyNameLength = _.get(ctrl.employerData, 'name.length', 0);
            if (!isCompaniesFieldEmpty || companyNameLength < MIN_COMPANY_NAME_LENGTH_TO_SEARCH) {
                return;
            }

            ctrl.isCompaniesLoading = true;

            try {
                const { result: companies } = await this.identifiersService.searchCompanyByFirstNameParts([
                    ctrl.employerData.name,
                ]);
                const suggestionCompanies = _.chain(companies)
                    .map('printName')
                    .flatten()
                    .map((item) => ({
                        value: item,
                        text: item,
                    }))
                    .slice(0, MAX_SUGGEST_COMPANIES)
                    .value();
                for (const suggestionCompany of suggestionCompanies) {
                    if (!_.some(ctrl.defaultAssociatedEmployersSettings.settings.companies.selected, suggestionCompany)) {
                        ctrl.defaultAssociatedEmployersSettings.settings.companies.selected.push(suggestionCompany);
                    }
                }
            } catch (error) {
                Logger.error(error);
                NotificationService.error('EMPLOYER_DETAILS_FORM_COMPANIES_GENERATE_ERROR');
            }
            ctrl.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
            ctrl.isCompaniesLoading = false;
            this.$scope.$apply();
        };

        ctrl.searchForMatchCompanies = _.debounce(_searchForMatchCompanies, 1000);

        ctrl.onChangeCompanies = function () {
            ctrl.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
        };

        ctrl.onProgrammaticCampaignOptionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.programmaticCampaignType = value;
        };

        ctrl.onChangeAtsAutoUploadFilter = function (value) {
        };

        ctrl.onBeforeSpecialtyAdded = function ({ value }) {
            _.remove(ctrl.employerData.specialties.selected, (item) => item.value.toLowerCase() === value.toLowerCase());
        };

        ctrl.cleanUpDataToSave = function (data) {
            for (const path of ['companies', 'specialties', 'settings.atsAutoUploadFilter']) {
                const value = _.chain(data)
                    .get(path)
                    .get('selected')
                    .map('value')
                    .value();

                _.set(data, path, value);
            }
        };

        ctrl.submit = async function (form) {
            ctrl.isDataSaving = true;
            if (form.$invalid) {
                angular.forEach(form.$error, (field) => {
                    angular.forEach(field, (errorField) => {
                        errorField.$setTouched();
                    });
                });
                return;
            }
            try {
                ctrl.cleanUpDataToSave(ctrl.resellerEmployerData);

                const dataToUpdate = {
                    ...ctrl.resellerEmployerData,
                    defaultAssociatedEmployersSettings: ctrl.defaultAssociatedEmployersSettings,
                };
                await EmployerService.putEmployer(ctrl.resellerEmployerData._id, dataToUpdate);
                $window.history.back();
            } catch (error) {
                Logger.error(error);
                NotificationService.error('EMPLOYER_DETAILS_FORM_SPECIALTIES_GENERATE_ERROR');
            } finally {
                ctrl.isDataSaving = false;
            }
        };

        ctrl.cancel = function () {
            $window.history.back();
        };

        ctrl.onOfficeChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.office = value;
        };

        ctrl.onCampaignsForUserTEOptionsChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.defaultForRecruiterCampaignId = value;
        };

        ctrl.onCampaignsForUserEMOptionsChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.defaultForEmployerRepCampaignId = value;
        };

        ctrl.onCompaniesExcludeOptionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.defaultCompaniesExcludeOption = value;
        };

        ctrl.onEmployerPostScrapingEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isEmployerPostScrapingEnabled = value;
        };

        ctrl.onAtsAutoUploadFilterEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAtsAutoUploadFilterEnabled = value;
        };

        ctrl.onDefaultAccountManagerRecruiterChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.defaultAccountManagerRecruiter = value;
        };

        ctrl.onDefaultAssociatedRecruiterChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.defaultAssociatedRecruiter = value;
        };

        ctrl.onDefaultEmployerRepChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.defaultEmployerRep = value;
        };

        ctrl.onDiversityChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.isDiversityEnabled = value;
        };

        ctrl.onDepartmentsEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isDepartmentsEnabled = value;
        };

        ctrl.onCampaignEngagement = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isEngagementEnabled = value;
        };

        ctrl.onLinkedinConnections = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.areLinkedinConnectionsEnabled = value;
        };

        ctrl.onLinkedinInMailConnections = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.areLinkedinInMailConnectionsEnabled = value;
        };

        ctrl.onCampaignsAnalysisPage = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isCampaignsAnalysisPageEnabled = value;
        };
        ctrl.onswitchOnAutoCampaignOnCompleteCalibrationChangeChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.switchOnAutoCampaignOnCompleteCalibration = value;
        };

        ctrl.onAutoInviteToRateSettingChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAutoInviteToRateEnabled = value;
        };

        ctrl.onAutoCampaignTypeSelect = ({ value }) => {
            if (value === this.AutoCampaignTypes.HYBRID) {
                ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.selectedDiversityTarget = [];
                ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.autoCampaignType = value;
            } else if (_.isEmpty(ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.selectedDiversityTarget)) {
                ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.autoCampaignType = this.AutoCampaignTypes.REGULAR;
            } else {
                ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.autoCampaignType = this.AutoCampaignTypes.DIVERSITY;
            }
        };

        ctrl.getAutoCampaignValue = (type) => (type === this.AutoCampaignTypes.REGULAR ? this.AutoCampaignTypes.DIVERSITY : type);

        ctrl.onAutoCampaignDiversityOptionCheck = (value, field) => {
            const diversityTarget = _.get(ctrl, 'employerData.settings.autoCampaignOptions.selectedDiversityTarget', []);
            const updatedDiversityTarget = value ? _.uniq([field, ...diversityTarget]) : _.filter(diversityTarget, (v) => v !== field);
            ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.selectedDiversityTarget = updatedDiversityTarget;
            this.onAutoCampaignTypeSelect({ value: ctrl.defaultAssociatedEmployersSettings.settings.autoCampaignOptions.autoCampaignType });
        };

        ctrl.onPositionRecommendations = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isPositionRecommendationsEnabled = value;
        };

        ctrl.onDiversityReportChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isDiversityReportEnabled = value;
        };

        ctrl.onDiversityTagChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isDiversityTagEnabled = value;
        };

        ctrl.openTurnOffAtsJobIdConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsJobIdConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_ID_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_ID_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => res(false),
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        ctrl.openActiveCampaignsExistDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'OpenActiveCampaignsExistDialog',
                title: 'Please stop all active campaigns first in Campaign tab',
                body: 'Please stop all active campaigns first in Campaign tab',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => res(false),
            });
        });

        ctrl.onAllowTalenyaDefaultEmployerRepForAtsPositions = ({ value }) => {
            // Since original definition changed settings meaning on ui reverted
            ctrl.defaultAssociatedEmployersSettings.settings.allowTalenyaDefaultEmployerRepForAtsPositions = !value;
        };

        ctrl.onAtsJobIdChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobId;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsJobIdConfirmDialog(value);
                if (isSwitchedOff) {
                    ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobId = value;
                    RouteService.sendEmployerAtsSettingUpdatesNotification({
                        employerId: ctrl.employerData._id,
                        settingName: 'showAtsJobId',
                    });
                    return isSwitchedOff;
                }
                return false;
            }
            ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobId = value;
        };

        ctrl.openTurnOffAtsJobUrlConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsJobUrlConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_JOB_URL_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_JOB_URL_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => {
                    res(false);
                },
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        ctrl.onAtsJobUrlChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobUrl;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsJobUrlConfirmDialog(value);
                if (isSwitchedOff) {
                    ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobUrl = value;
                    RouteService.sendEmployerAtsSettingUpdatesNotification({
                        employerId: ctrl.employerData._id,
                        settingName: 'showAtsJobUrl',
                    });
                    return isSwitchedOff;
                }
                return false;
            }
            ctrl.defaultAssociatedEmployersSettings.settings.showAtsJobUrl = value;
        };

        ctrl.openTurnOffAtsRecruiterConfirmDialog = () => new Promise((res) => {
            this.ModalDialogService.showDialog({
                modalDialogId: 'TurnOffAtsRecruiterConfirmDialog',
                title: 'EMPLOYER_ACCOUNT_DETAILS_ATS_RECRUITER_VERIFICATION_POPUP_TITLE',
                body: 'EMPLOYER_ACCOUNT_DETAILS_ATS_RECRUITER_VERIFICATION_POPUP_BODY',
                showCancelButton: true,
                showCloseButton: false,
                customZIndex: 2000,
                onClose: () => {
                    res(false);
                },
                buttons: [
                    {
                        label: 'YES',
                        className: 'primary-button',
                        onClick: () => { res(true); },
                    },
                ],
            });
        });

        ctrl.onAtsRecruiterChange = async ({ value }) => {
            const shouldOpenConfirmDialog = !value && ctrl?.employerData?.settings?.showAtsRecruiter;
            if (shouldOpenConfirmDialog) {
                const isSwitchedOff = await this.openTurnOffAtsRecruiterConfirmDialog(value);
                if (isSwitchedOff) {
                    ctrl.defaultAssociatedEmployersSettings.settings.showAtsRecruiter = value;
                    return isSwitchedOff;
                }
                return false;
            }
            ctrl.defaultAssociatedEmployersSettings.settings.showAtsRecruiter = value;
        };

        ctrl.onContactForEmployerChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isContactForEmployerEnabled = value;
        };

        ctrl.onProfileHiddenDetailsPreviewChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isProfileHiddenDetailsPreviewEnabled = value;
        };

        ctrl.onShowManageJobChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.showManageJob = value;
        };

        ctrl.onProfileFeedbackModeEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isProfileFeedbackModeEnabled = value;
        };

        ctrl.onNewLandingPageEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isNewLandingPageEnabled = value;
        };

        ctrl.onResellerPartnerOptionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isResellerPartner = value;
        };

        ctrl.onShowWizardSamplesPageChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.showWizardSamplesPage = value;
        };

        ctrl.onBulkActionsContactByLinkedInEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isBulkActionsContactByLinkedInEnabled = value;
        };

        ctrl.onJobWizardFastRatingEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isJobWizardFastRatingEnabled = value;
        };

        ctrl.onOnlyFastRatingAllowedChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isOnlyFastRatingAllowed = value;

            if (!value) {
                ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyEnabled = false;
                ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualFlowEnabled = false;
                ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualMessagingEnabled = false;
            }
        };

        ctrl.onSkipCalibrationForSimilarJobsAllowedChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isSkipCalibrationForSimilarJobsAllowed = value;
        };

        ctrl.onRecalibrationEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isRecalibrationEnabled = value;
        };

        ctrl.onManualQualifyEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyEnabled = value;

            if (!value) {
                ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualFlowEnabled = false;
                ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualMessagingEnabled = false;
            }
        };

        ctrl.onManualQualifyLowTalentPoolEnabled = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyLowTalentPoolEnabled = value;
        };

        ctrl.onManualQualifyManualFlowEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualFlowEnabled = value;
        };

        ctrl.onManualQualifyManualMessagingEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isManualQualifyManualMessagingEnabled = value;
        };

        ctrl.onGDPRChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isGDPR = value;
        };

        ctrl.onChangeIsCandidatePhoneRequired = ({ value }) => {
            // eslint-disable-next-line max-len
            let requiredCandidateContacts = [...(ctrl.defaultAssociatedEmployersSettings.settings.interestedCandidateRequiredContacts || [])];
            requiredCandidateContacts = value
                ? [...requiredCandidateContacts, InterestedCandidateContacts.PHONE]
                : requiredCandidateContacts.filter((f) => f !== InterestedCandidateContacts.PHONE);

            ctrl.defaultAssociatedEmployersSettings.settings.interestedCandidateRequiredContacts = requiredCandidateContacts;
        };

        ctrl.cityChanged = function (location, index) {
            if (!location.state && location.country != 'IL') {
                return;
            }
            ctrl.currentCityIndex = index;
            if (!location.city) {
                ctrl.cityFocusedOn = 0;
                ctrl.filteredCity = ctrl.locations.countries[location.countryId].states[location.state];
                return;
            }
            const ans = [];
            for (let i = 0; i < ctrl.locations.countries[location.countryId].states[location.state].length; i++) {
                if (ctrl.locations.countries[location.countryId].states[location.state][i].toLowerCase()
                    .indexOf(location.city.toLowerCase()) >= 0) {
                    ans.push(ctrl.locations.countries[location.countryId].states[location.state][i]);
                }
            }
            ctrl.cityFocusedOn = 0;
            location.showDropDownCity = true;
            ctrl.filteredCity = ans;
        };

        ctrl.onShortUrlChange = (value) => {
            ctrl.defaultAssociatedEmployersSettings.settings.shortUrl = value;
        };

        ctrl.editAssociatedEmployer = function () {
            $state.go(
                'employer.editAssociatedEmployer',
                { empId: ctrl.associatedEmployersIds[0] },
            );
        };

        ctrl.onDemoEmployerOptionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isDemoEmployer = value;
        };

        ctrl.onUploadMonitorOptionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isUploadMonitorEnabled = value;
        };

        ctrl.onAutoContactAutoSelectChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAutoContactAutoSelectEnabled = value;
        };

        ctrl.onAutoQualifyChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAutoQualifyEnabled = value;
        };

        ctrl.onAtsJobsAutoPushStatusChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAtsJobsAutoPushStatusEnabled = value;
        };

        ctrl.onAIJobDescriptionGenerationEnabledChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isAIJobDescriptionGenerationEnabled = value;
        };

        ctrl.onCandidateFastApplyChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isCandidateFastApplyEnabled = value;
        };

        ctrl.onFastCalibrationChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isFastCalibrationEnabled = value;
        };

        ctrl.onMultipleSelectionChange = ({ value }) => {
            ctrl.defaultAssociatedEmployersSettings.settings.isMultipleSelectionEnabled = value;
        };

        ctrl.$onInit = async () => {
            const [
                { result: offices },
                countriesList,
                { result: recruiterList },
            ] = await Promise.all([
                OfficeService.getOffices(),
                staticDataService.getStaticData('countries'),
                ctrl.isSuperUser
                    ? RecruiterService.getRecruiters(['_id', 'fullName'])
                    : Promise.resolve([]),
            ]);

            ctrl.isDoNotReplyEnabled = RouteService.getSystemPreference('isDoNotReplyEnabled');
            ctrl.isManualQualifyFlowEnabled = RouteService.getSystemPreference('manualQualifyFlowEnabled');
            ctrl.isManualMessagingEnabledInSystem = RouteService.getSystemPreference('isManualQualifyManualMessagingEnabled');

            const recruiterOptions = _.chain(recruiterList)
                .reduce((accumulator, { _id, fullName }) => {
                    if (!fullName) {
                        return accumulator;
                    }
                    return [
                        ...accumulator,
                        {
                            value: _id, label: fullName, sorting: fullName.toLowerCase(),
                        },
                    ];
                }, [])
                .sortBy(['sorting'])
                .value();

            ctrl.associatedRecruiterOptions = recruiterOptions;
            ctrl.accountManagerRecruiterOptions = recruiterOptions;
            ctrl.countriesList = countriesList;
            ctrl.officeOptions = (offices || []).map((office) => ({ label: office, value: office }));
        };

        ctrl.init();
    }

    getIsGenerateSpecialtiesButtonEnabled() {
        return _.get(this.employerData, 'companies.selected.length', 0) > 0;
    }

    $onChanges() {
        this.isGenerateSpecialtiesButtonEnabled = this.getIsGenerateSpecialtiesButtonEnabled();
    }
}

export const defaultAssociatedEmployersSettingConfiguration = {
    template,
    controller: DefaultAssociatedEmployersSettings,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('defaultAssociatedEmployersSettings', defaultAssociatedEmployersSettingConfiguration);
